<template>
    <div class="yida"> 
        <div class="banner"></div>
        <div class="yuansheng">
            <div class="yuansheng-left">
                <img src="./img-info/img-up-imgs1.png" alt="">
                <div class="ziti">
                    <p class="yuansheng-title">阿里云原生</p>
                    <p class="yuansheng-info">弹性扩容、动态调度、</p>
                    <p class="yuansheng-info">自动化运维</p>
                </div>
            </div>
            <div class="yuansheng-right">
                <img src="./img-info/img-up-imgs2.png" alt="">
                <div class="ziti">
                    <p class="yuansheng-title">钉原生</p>
                    <p class="yuansheng-info">钉钉官方低代码应用搭建平</p>
                    <p class="yuansheng-info">台，和钉钉能力默认打通</p>
                </div>
            </div>
        </div>
        <div class="cont1">
            <p class="fabu">宜搭应用工厂，全新发布</p>
            <p class="lianjie">通过连接器+互动卡片+业务编排3步完成酷应用开发并上架至群应用市场，加速企业业务应用的“酷应用化”，让创新更简单。</p>
            <div class="video" >
                <video loop poster="../assets/other/yidao-img.jpg" type="video/mp4"   :controls="controls" @click="clickOk" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="h5" x5-video-player-fullscreen="true">
                    <source src="../assets/other/yidong-video.mp4">
                </video>
            </div>
            <p class="fabu fabu2">宜搭更懂你的业务</p>
            <p class="yewu">强大的平台能力，逐层递进的交互体验，满足不同层次的用户需求</p>
            <ul class="yewu-ul">
                <li>
                    <div class="left-yewu">
                        <img src="./img-info/img-yida-s1.png" alt="">
                    </div>
                    <div class="right-yewu">
                        <p class="p1">应用可视化搭建</p>
                        <p class="p2">端到端，一站式解决方案</p>
                        <p class="p3">数据存储、运行环境、服务器、网络安全等，平台为你全部搞定。此外，宜搭还提供了强大的弹性计算、动态扩容能力，为你的业务高效、稳定的运行保驾护航。</p>
                        <p class="p2">低代码的应用搭建平台</p>
                        <p class="p3">将页面元素封装为基础组件和业务组件，将业务规则、权限等封装为规则配置、公式和可拖拽的流程设计器，通过托拽以及配置，无需编写代码，即可完成符合业务需求的应用系统的搭建。</p>
                    </div>
                </li>
                <li>
                    <div class="left-yewu">
                        <p class="p1">根据业务灵活定制</p>
                        <p class="p2">表单</p>
                        <p class="p3">数据提报或收集，实现数据协作与共享；</p>
                        <p class="p2">流程</p>
                        <p class="p3">带有流程审批功能的数据收集，如报销、请假申请等等工作流程。</p>
                        <p class="p2">报表</p>
                        <p class="p3">业务线上化，积累的数据，可设置实时查看的报表、仪表盘，让业务状况一目了然。</p>
                    </div>
                    <div class="right-yewu">
                        <img src="./img-info/img-yida-s2.gif" alt="">
                    </div>
                </li>
                <li>
                    <div class="left-yewu">
                        <img src="./img-info/img-yida-s3.png" alt="">
                    </div>
                    <div class="right-yewu">
                        <p class="p1">集成钉钉快速应用</p>
                        <p class="p2">组织架构</p>
                        <p class="p3">默认使用钉钉企业通讯录，流程审批可基于组织架构，方便、快捷。</p>
                        <p class="p2">消息通知</p>
                        <p class="p3">支持钉钉消息、钉钉待办，确保重要事项消息必达。</p>
                        <p class="p2">企业工作台</p>
                        <p class="p3">搭建好的应用可快速接入企业工作台，高效实现在线协同、移动办公。</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="contss">
            <div class="boxss">
                <div class="liubai"></div>
                <p class="pp1">宜搭更懂你的业务</p>
                <p class="pp2">强大的平台能力，逐层递进的交互体验，满足不同层次的用户需求</p>
                <ul class="biaozhun-ul">
                    <li>
                        <img src="./img-info/img-yida-icon-s1.png" alt="">
                        <div>
                            <p class="pb1">个性化定制</p>
                            <p class="pb2">快速搭建、便捷试用</p>
                            <p class="pb2">低成本变更</p>
                            <p class="pb2">交付完全贴合业务需求的应用</p>
                        </div>
                    </li>
                    <li>
                        <img src="./img-info/img-yida-icon-s2.png" alt="">
                        <div>
                            <p class="pb1">信息安全</p>
                            <p class="pb2">提供DDoS攻击防御</p>
                            <p class="pb2">WEB应用防火墙</p>
                            <p class="pb2">接口安全检测等安全服务</p>
                        </div>
                    </li>
                    <li>
                        <img src="./img-info/img-yida-icon-s3.png" alt="">
                        <div>
                            <p class="pb1">性能稳定</p>
                            <p class="pb2">阿里云技术及计算能力</p>
                            <p class="pb2">默认提供大数据、高并发的解决方案</p>
                            <p class="pb2">承诺99.999%高可用依</p>
                        </div>
                    </li>
                    <li>
                        <img src="./img-info/img-yida-icon-s4.png" alt="">
                        <div>
                            <p class="pb1">集成钉钉</p>
                            <p class="pb2">助力企业快速实现</p>
                            <p class="pb2">组织在线、沟通在线</p>
                            <p class="pb2">协同在线、业务在线</p>
                        </div>
                    </li>
                    <li>
                        <img src="./img-info/img-yida-icon-s5.png" alt="">
                        <div>
                            <p class="pb1">阿里技术体系</p>
                            <p class="pb2">遵循阿里巴巴技术规约标准</p>
                            <p class="pb2">无缝集成达摩院、高德地图、阿里云</p>
                            <p class="pb2">IOT等算法或产品</p>
                        </div>
                    </li>
                    <li>
                        <img src="./img-info/img-yida-icon-s6.png" alt="">
                        <div>
                            <p class="pb1">开放的生态</p>
                            <p class="pb2">应用/市场+云栖社区</p>
                            <p class="pb2">组件、页面插件均可自定义</p>
                            <p class="pb2">开发的应用和插件可发布到开放市场</p>
                        </div>
                    </li>
                </ul>
                <div class="liubai"></div>
            </div>
        </div>
    </div>
</template>
        
<script>
export default {
   data () {
    return {
        controls:false
    }
   },
   methods: {
        clickOk(){
            this.controls = true
        }
   }
}
</script>
<style lang='less' scoped>
.yida{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/cpfw_yd_1920337.5@1x-tuya.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .yuansheng{
        width: 80%;
        margin: 50px auto;
        display: flex;
        padding: 50px;
        .yuansheng-left,.yuansheng-right{
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            img{
                width: 120px;
                height: 88px;
                margin: 0px 30px 0px 50px;
            }
            .ziti{
                height: 100%;
                padding-top: 20px;
                .yuansheng-title{
                    font-size: 32px;
                    color:#000000;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .yuansheng-info{
                    font-size: 21px;
                    margin-top: 5px;
                }
            }
        }
    }
    .cont1{
        background-color: rgba(249, 249, 249, 1);
        padding-top: 40px;
        padding-bottom: 40px;
        .fabu{
            color: #0089ff;
            font-weight: bold;
            font-size:35px;
            text-align: center;
            letter-spacing: 2px;
            padding: 20px;
        }
        .fabu2{
          color: #000; 
          margin-top: 50px; 
        }
        .lianjie{
            font-size: 21px;
            color: #000;
            text-align: center;
            letter-spacing: 1px;
            padding: 10px;
        }
        .video{
            width: 100%;
            height: 496px;
            margin-top: 30px;
            video{
                width: 40%;
                height: 100%;
                margin-left: 30%;
            }
        }
        .yewu{
            color:#808080;
            font-size: 21px;
            text-align: center;
            letter-spacing: 1px;
            padding: 10px;
        }
        .yewu-ul{
            width: 80%;
            margin: 50px auto;
            li{
                width: 100%;
                margin-bottom: 40px;
                background-color: #fff;
                padding: 30px;
                display: flex;
                .left-yewu{
                    width: 50%;
                    img{
                        width: 100%;
                    }
                    .p1{
                        color:#0089ff;
                        font-size:26px;
                        line-height:1.5;
                        font-weight: bold;
                         margin-left: 30px;
                    }
                    .p2{
                        font-size:21px;
                        color:#666666;
                        margin-top: 10px;
                         margin-left: 30px;
                    }
                    .p3{
                        font-size: 14px;
                        line-height:1.5;
                        color:#999999;
                        margin-top: 5px;
                         margin-left: 30px;
                    }
                }
                .right-yewu{
                    width: 50%;
                    img{
                        width: 100%;
                    }
                    .p1{
                        color:#0089ff;
                        font-size:26px;
                        line-height:1.5;
                        font-weight: bold;
                        margin-left: 30px;
                    }
                    .p2{
                        font-size:21px;
                        color:#666666;
                        margin-top: 10px;
                        margin-left: 30px;
                        
                    }
                    .p3{
                        font-size: 14px;
                        line-height:1.5;
                        color:#999999;
                        margin-top: 5px;
                        margin-left: 30px;

                    }
                }
                
                
            }
        }
    }
    .contss{
        width: 100%;
        background-color: #fff;
        .boxss{
            width: 80%;
            margin: 0 auto;
            .liubai{
                height: 40px;
            }
            .pp1{
                font-size:35px;
                text-align:center;
                color:#000000;
                line-height:1.8;
            }
            .pp2{
                font-size:21px;
                color:#999999;
                line-height:1.5;
                text-align:center;
                margin-top: 15px;
            }
            .biaozhun-ul{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                li{
                    width: 18%;
                    margin-top: 30px;
                    display: flex;
                    background-color: rgba(249, 249, 249, 1);
                    margin-right: 1.5%;
                    padding: 30px;
                    img{
                        width: 85px;
                        height: 85px;
                        margin-right: 20px;
                        margin-top: 48.5px;
                    }
                    .pb1{
                        font-size:24px;
                        color:#000000;
                        font-weight: bold;
                        letter-spacing: 1px;
                        margin-bottom: 10px;
                    }
                    .pb2{
                        color:#696969;
                        font-size:18px;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}
</style>
